/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Share_Revoke_PendingInputs */

const en_error_crm_share_revoke_pending = /** @type {(inputs: Error_Crm_Share_Revoke_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The share is revoked, but its link could not be withdrawn yet. Try again in a moment.`)
};

/**
* | output |
* | --- |
* | "The share is revoked, but its link could not be withdrawn yet. Try again in a moment." |
*
* @param {Error_Crm_Share_Revoke_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_share_revoke_pending = /** @type {((inputs?: Error_Crm_Share_Revoke_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Share_Revoke_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_share_revoke_pending(inputs)
});